module.exports = __webpack_public_path__ + "static/media/shield.db0df18f.svg";